import { addAsync as _addAsync } from "../../api";

const BASE_URL = "/coc/requests";

export async function addAsync(requestId, payload) {
    return _addAsync({ url: `${BASE_URL}/${requestId}/evidences/${payload.cocRequestEvidencesId}/analysis`, data: payload });
}
